import { render, staticRenderFns } from "./ObsExampleDialog.vue?vue&type=template&id=19b1f0cc"
import script from "./ObsExampleDialog.vue?vue&type=script&lang=js"
export * from "./ObsExampleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports